import { objectKeys } from './prototypeUtils';

export const objectToQueryString = <T extends Record<string, string | number | boolean>>(obj: T) => {
  return objectKeys(obj)
    .filter((key) => Boolean(obj[key]))
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');
};
